import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bbca132"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "load-window" }
const _hoisted_2 = { class: "load-window__label" }
const _hoisted_3 = { key: 0 }

import { ref } from "vue";
import { validateCharacter } from "@/shared/helpers/validators";
import Button from "@/shared/ui/Button/Button.vue";
import UploadIcon from "@/shared/ui/Icon/svg/UploadIcon.vue";
import { Character } from "@/types";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadWindow',
  emits: ["close"],
  setup(__props, { emit }) {

// TODO: Add file drop support


const store = useCharactersStore();

const { characters } = storeToRefs(store);
const { changeCharacter, setCharacter } = store;
const loadedCharacters = ref<Character[]>([]);
const errors = ref<string[]>([]);
const isValidCharacters = ref(true);

const load = (e: any) => {
	if (!e.target.files.length) {
		loadedCharacters.value = [];
		return;
	}
	isValidCharacters.value = true;

	const files = [...e.target.files] as File[];

	files.forEach((file, index) => {
		const reader = new FileReader();
		reader.readAsText(file, "UTF-8");
		reader.onload = (event) => {
			if (typeof event?.target?.result === "string") {
				const character = JSON.parse(event.target.result);
				if (validateCharacter(character)) {
					loadedCharacters.value.push(character as Character);
				} else {
					isValidCharacters.value = false;
					errors.value.push(
						`Unable to load '${
							character.name || index + "nd"
						}' character.`
					);
				}
			}
		};
		reader.onerror = () => (isValidCharacters.value = false);
	});
};

const confirmLoading = () => {
	loadedCharacters.value.forEach((character) => {
		setCharacter(character);
	});
	errors.value = [];
	loadedCharacters.value = [];
	changeCharacter(characters.value.length - 1);
	emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("please-select-character-file")) + ": ", 1),
      _createVNode(UploadIcon, { class: "load-window__upload" }),
      _createElementVNode("input", {
        accept: ".fate",
        class: "load-window__input",
        multiple: "",
        type: "file",
        onChange: load
      }, null, 32)
    ]),
    (isValidCharacters.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loadedCharacters.value, (character, index) => {
            return (_openBlock(), _createElementBlock("h3", {
              key: character.name + index
            }, [
              _createElementVNode("strong", null, _toDisplayString(character.name) + ", ", 1),
              _createTextVNode(" " + _toDisplayString(character.race) + " " + _toDisplayString(` (${character.level} ${_ctx.$t("level").toLocaleLowerCase()})`), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(Button, {
      class: "load-window__button",
      title: _ctx.$t('ui-confirm'),
      disabled: 
				errors.value.length || (errors.value.length && loadedCharacters.value.length)
			,
      onClick: confirmLoading
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("ui-confirm")), 1)
      ]),
      _: 1
    }, 8, ["title", "disabled"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
      return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
    }), 128))
  ]))
}
}

})